
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('performanceDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <template  v-if="this.$parent.foundPerformances.length > 0">
                        <label class="form-label">{{ $t('cannotDeletePerformance') }}</label>
                        <div v-for="(performance, i) in this.$parent.foundPerformances" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/lifecycle/' + performance.lifeCycleId ">
                                {{ performance.name }}
                            </RouterLink>
                        </div>
                     </template>
                    <p v-else>{{ $t('wannaDeleteThisPerformance') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deletePerformance" :disabled="this.$parent.foundPerformances.length > 0">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import PerformanceApi from "../../api/server/performance";

export default {
    name: "performanceDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deletePerformance() {
            await PerformanceApi.performanceDelete(this.$parent.$route.params.id, this.$parent.performanceToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        },
    }
};
</script>